// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".colorpalette-product__items{display:flex;flex-wrap:wrap;margin:-10px}.colorpalette-product__item{padding:10px}.colorpalette-product__item--loadmore{cursor:pointer}.colorpalette-product .button{min-height:45px;display:inline-flex;justify-content:center;align-items:center}.colorpalette-product span.button{pointer-events:none}", ""]);
// Exports
module.exports = exports;
